import {
  AssetBody,
  AssetObject,
  DeleteSiteAsset,
} from "@vviinn/user-managment-client-ts";

import { useApi } from "../../api";
import {
  useAppDispatch,
  deleteAsset,
  fetchAssets,
  upsertAsset,
} from "../../store";
import {
  synchronizeSchema,
  upsertCustomFields,
} from "../../store/features/site/customFields";
import { SiteCustomField } from "@vviinn/user-managment-client-ts/dist/models/SiteCustomField";
import { fetchCampaignsAttributes } from "../../store/features/campaigns/fetch";

export const Communication = () => {
  const { getApi } = useApi();
  const dispatch = useAppDispatch();

  return {
    async getAssetsList(
      siteId: number,
      companyId: string,
    ): Promise<AssetObject[]> {
      const api = await getApi();
      const response = await dispatch(
        fetchAssets({
          api,
          value: {
            companyId,
            siteId,
          },
        }),
      );
      return response.payload as AssetObject[];
    },

    async upsertAssetItem(
      siteId: number,
      companyId: string,
      assetBody: AssetBody,
    ): Promise<AssetObject> {
      const api = await getApi();
      const response = await dispatch(
        upsertAsset({
          api,
          value: {
            companyId,
            siteId,
            assetBody,
          },
        }),
      );
      return response.payload as AssetObject;
    },

    async deleteAssetItem(
      siteId: number,
      companyId: string,
      assetId: string,
    ): Promise<DeleteSiteAsset> {
      const api = await getApi();
      const response = await dispatch(
        deleteAsset({
          api,
          value: {
            companyId,
            siteId,
            assetId,
          },
        }),
      );
      return response.payload as DeleteSiteAsset;
    },

    async upsertCustomFieldsData(
      siteId: number,
      companyId: string,
      filterData: SiteCustomField[],
    ): Promise<SiteCustomField[]> {
      const api = await getApi();
      const response = await dispatch(
        upsertCustomFields({
          api,
          value: {
            companyId,
            siteId,
            siteCustomFieldsRequestBody: {
              customFields: filterData,
              reset: true,
            },
          },
        }),
      );
      if (response.payload) {
        dispatch(synchronizeSchema({ api, value: { companyId, siteId } }));
        dispatch(
          fetchCampaignsAttributes({ api, value: { companyId, siteId } }),
        );
      }
      return response.payload as SiteCustomField[];
    },
  };
};
